import React, { useState, useContext, useEffect, useRef } from 'react';
import axiosConn from '../../axiosConn';
import useMobileView from '../../hooks/useMobileView';
import Sidebar from '../../components/sidebar/Sidebar';
import Rightbar from '../../components/rightbar/Rightbar';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { fetchIPData } from '../../utils/ipUtils';
import { getAirtimeAccessToken } from '../../utils/airtimeUtils';
import { AuthContext } from '../../context/AuthContext';
import { countryCodeToIso } from '../../utils/countryToIsoUtil';
import { useGetCurrPlayer } from '../../hooks/useGetCurrPlayer';
import ClipLoader from 'react-spinners/ClipLoader'; // Import the spinner component
import {
  usdJGKDecimalConversionRate,
  usdJGKConversionRate,
} from '../../utils/config';
import { useSuspension } from '../../context/SuspensionContext';
import { isSameDay } from '../../utils/dateUtil';
// import SendVerification from '../../components/sendVerification/SendVerification';

import './airtime.css';
import '../jgkToken/jgktoken.css';

export const AirtimeTopUp = ({ embedded = false }) => {
  const { player } = useContext(AuthContext);
  const { isSuspended } = useSuspension();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [lastTransactionId, setLastTransactionId] = useState('');
  const phoneCountryRef = useRef('');
  const [step, setStep] = useState(0);
  const [operatorData, setOperatorData] = useState(null);
  const [ip, setIP] = useState('');
  const [countryName, setCountryName] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [accessToken, setAccessToken] = useState(null);
  const [showMin, setShowMin] = useState(0);
  const [showMax, setShowMax] = useState(0);
  const [jgkAmount, setJgkAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [airtimeTopupFee, setAirtimeTopupFee] = useState(0);
  const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState('');
  const [isLocal, setIsLocal] = useState(false);
  const [currPlayer, setCurrPlayer] = useState({});
  const [topupDate, setTopupDate] = useState(null); // State to store the top-up date

  // console.log(reloadlyAccessToken);
  const handlePhoneNumberChange = (value, country) => {
    // console.log('Country:', country);
    setPhoneNumber(value);
    const dialCode = String(country?.dialCode || '');
    const isoFromDial = dialCode ? countryCodeToIso[dialCode] : '';
    const isoFromCountry = country?.countryCode
      ? String(country.countryCode).toUpperCase()
      : '';
    const isoCode = isoFromDial || isoFromCountry || '';
    phoneCountryRef.current = isoCode;
    setPhoneNumberCountryCode(isoCode);
    // console.log('Phone Number:', value);
    // console.log('Country ISO Code:', isoCode);
  };

  const onSuccess2 = (data) => {
    // console.log('data: ', data);
  };

  const onError2 = (err) => {
    // console.log('err: ', err);
  };

  const { data: data2, status: status2 } = useGetCurrPlayer(
    onSuccess2,
    onError2,
    player,
  );
  // console.log(data);

  useEffect(() => {
    let mounted = true;
    //set conversations
    if (status2 === 'success') {
      if (!mounted) return;
      setCurrPlayer(data2);
    }
    return () => {
      mounted = false;
    };
  }, [status2, data2]);

  useEffect(() => {
    let mounted = true;

    const fetchAccessToken = async () => {
      try {
        const token = await getAirtimeAccessToken();
        // console.log(token);
        if (mounted) {
          setAccessToken(token);
        }
      } catch (error) {
        console.error('Failed to fetch airtime access token:', error);
      }
    };

    fetchAccessToken();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const getData = async () => {
      const data = await fetchIPData();
      if (data) {
        setIP(data.ip);
        setCountryName(data.country_name);
        setCountryCode(data.country_code);
        // console.log(data);
      }
    };
    getData();
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    // console.log('Confirm button clicked');

    try {
      // Ensure required data is available
      if (!operatorData.operatorId || !amount || !phoneNumber) {
        throw new Error('Missing required fields');
      }

      const requestBody = {
        operatorId: operatorData.operatorId, // required
        amount: amount, // required
        useLocalAmount: isLocal, // default false
        customIdentifier: `${
          typeof window !== 'undefined' ? window.location.origin : ''
        } ${player.data.player.playerId}-${phoneNumber}-${Date.now()}`,
        recipientPhone: {
          // required
          countryCode: phoneNumberCountryCode,
          number: phoneNumber,
        },
      };
      console.log('[airtime][confirm] submitting cashout', {
        sender: player?.data?.player?._id || null,
        jgkAmount,
        operatorId: requestBody.operatorId,
        amount: requestBody.amount,
        useLocalAmount: requestBody.useLocalAmount,
        countryCode: requestBody?.recipientPhone?.countryCode || null,
        phoneNumber: requestBody?.recipientPhone?.number || null,
        hasReloadlyToken: !!accessToken?.access_token,
      });

      const response = await axiosConn.post(
        'jgkTokenTransactions/jgkCashoutToAirTime',
        {
          sender: player.data.player._id,
          jgkAmount: jgkAmount,
          requestBody: requestBody,
          reloadlyAirtimeTopUpAccessToken: accessToken.access_token,
        },
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );
      console.log('[airtime][confirm] cashout response', {
        status: response?.status,
        data: response?.data || null,
      });

      // const response = await axios.post(url, requestBody, {
      //   headers: {
      //     Authorization: `Bearer ${accessToken.access_token}`,
      //     Accept: 'application/com.reloadly.topups-v1+json',
      //     'Content-Type': 'application/json',
      //   },
      // });

      // console.log('Response Data:', response.data.data);
      // Save the current date as the last top-up date
      if (topupDate) {
        localStorage.setItem(
          `lastTopupDate_${player.data.player._id}`,
          topupDate.toISOString(),
        );
      }
      setSuccess('Airtime added instantly.');
      setLastTransactionId(response?.data?.data?.transactionId || '');
      setStep(4);

      // Update the player's JGK tokens
      //api call to backend to update player's jgk tokens
    } catch (err) {
      const backendDetail =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message;
      console.error('[airtime][confirm] cashout error', {
        status: err?.response?.status || null,
        data: err?.response?.data || null,
        message: err?.message || null,
      });
      setError(`Top-up failed. Please try again. ${backendDetail}`);
    } finally {
      setLoading(false);
      console.log('Loading state set to false');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (isSuspended) {
      setError('You are temporarily suspended from making transactions.');
      setLoading(false);
      return;
    }

    // Check if the player's profile photo is set
    const profilePhoto = player?.data?.player?.profilePhoto || '';
    if (!profilePhoto || String(profilePhoto).includes('noAvatar')) {
      setError('Profile photo must be set before performing a top-up');
      setLoading(false);
      return;
    }

    // can't do this because email verify sometimes gets block
    // as spam.
    // Check if the player's account is verified
    // if (!player.data.player.verified) {
    //   setError('Verify your account before performing a top-up');
    //   setLoading(false);
    //   return;
    // }

    // Check if the player has already performed a top-up today
    const lastTopupDate = localStorage.getItem(
      `lastTopupDate_${player.data.player._id}`,
    );
    const now = new Date();
    setTopupDate(now);
    if (lastTopupDate && isSameDay(new Date(lastTopupDate), now)) {
      setError('You can only perform one top-up per day');
      setLoading(false);
      return;
    }

    try {
      if (!accessToken || !accessToken.access_token) {
        throw new Error('Access token is not available');
      }
      // console.log(accessToken.access_token);
      const countryIsoCode =
        phoneCountryRef.current ||
        phoneNumberCountryCode ||
        (countryCode ? String(countryCode).toUpperCase() : '');
      if (!countryIsoCode) {
        setError('Select a valid country code to continue.');
        setLoading(false);
        return;
      }
      // console.log('Access Token:', accessToken.access_token);
      // console.log('Country ISO Code:', countryIsoCode);
      // console.log('Phone Number:', phoneNumber);
      console.log('[airtime][operator] auto-detect request', {
        phoneNumber,
        countryIsoCode,
        hasReloadlyToken: !!accessToken?.access_token,
      });

      const response = await axiosConn.get(
        `https://topups.reloadly.com/operators/auto-detect/phone/${phoneNumber}/countries/${countryIsoCode}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
            Accept: 'application/com.reloadly.topups-v1+json',
          },
        },
      );
      console.log('[airtime][operator] auto-detect response', {
        status: response?.status,
        operatorId: response?.data?.operatorId || null,
        country: response?.data?.country?.isoName || null,
        supportsLocalAmounts: response?.data?.supportsLocalAmounts || false,
        minAmount: response?.data?.minAmount || null,
        maxAmount: response?.data?.maxAmount || null,
      });

      // console.log('Response Data:', response.data);
      setOperatorData(response.data);
      //check if player is local to the country to set useLocalAmount to true
      // console.log(countryCode, response.data?.country.isoName);
      const isLocal =
        countryCode === response.data?.country.isoName ? true : false;
      if (isLocal && response.data?.supportsLocalAmounts === true) {
        setIsLocal(isLocal);

        //set useLocalAmount to true
        setShowMin(response.data?.minAmount * response.data?.fx.rate);
        setShowMax(response.data?.maxAmount * response.data?.fx.rate);
        setAirtimeTopupFee(response.data?.fees.local);
      } else {
        setShowMin(response.data?.minAmount);
        setShowMax(response.data?.maxAmount);
        setAirtimeTopupFee(response.data?.fees.international);
      }
      setAmount(response.data?.minAmount);
      setJgkAmount(
        response.data?.minAmount * usdJGKConversionRate +
          airtimeTopupFee * response.data?.fx.rate * usdJGKConversionRate,
      );
      // console.log(isLocal);
      const fee = isLocal
        ? response.data?.fees.localFee
        : response.data?.fees.international;
      console.log(fee);
      console.log(
        'JGK Amount:',
        response.data?.minAmount * usdJGKConversionRate +
          fee * response.data?.fx.rate * usdJGKConversionRate,
      );
      setSuccess('');
      setStep(2);
    } catch (err) {
      const backendDetail =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message;
      console.error('Error:', err?.response?.data || err);
      setError(`Top-up failed. Please try again. ${backendDetail}`);
    } finally {
      setLoading(false);
      console.log('Loading state set to false');
    }
  };

  const handleChange = (e) => {
    const newAmount = e.target.value === '' ? '' : parseFloat(e.target.value);
    setAmount(newAmount);

    if (newAmount === '') {
      setJgkAmount(0);
      return;
    }

    if (newAmount > 3) {
      setError('Amount should be less than or equal to $3');
      return;
    }
    // Calculate the initial JGK amount
    let newJgkAmount =
      newAmount * usdJGKConversionRate +
      airtimeTopupFee * operatorData.fx.rate * usdJGKConversionRate;

    // Add an additional 3% fee
    // newJgkAmount = newJgkAmount + newJgkAmount * 0.03;

    setJgkAmount(newJgkAmount);
    console.log('Amount:', newAmount);
    console.log(
      'JGK Amount:',
      newJgkAmount,
      'Players JGK Tokens:',
      currPlayer?.jgkTokens,
    );

    // Set error if currPlayer.jgkTokens is less than jgkAmount
    if (currPlayer?.jgkTokens < newJgkAmount) {
      setError(`Insufficient JGK, send a lower amount.`);
    } else {
      setError('');
    }
  };

  const steps = [
    { key: 'carrier', label: 'Carrier' },
    { key: 'phone', label: 'Phone' },
    { key: 'amount', label: 'Amount' },
    { key: 'confirm', label: 'Confirm' },
  ];
  const activeStep = Math.min(step, steps.length - 1);
  const numericAmount = Number(amount || 0);
  const amountInRange =
    Number.isFinite(numericAmount) &&
    numericAmount >= showMin &&
    numericAmount <= showMax;
  const hasBalance = currPlayer?.jgkTokens >= jgkAmount;
  const canContinueAmount =
    amountInRange && hasBalance && numericAmount > 0 && numericAmount <= 3;
  const deliveryAmount =
    operatorData?.fx?.rate && numericAmount
      ? (operatorData.fx.rate * numericAmount).toFixed(2)
      : null;

  const handleReset = () => {
    setStep(0);
    setError('');
    setSuccess('');
    setPhoneNumber('');
    setOperatorData(null);
    setAmount(0);
    setJgkAmount(0);
    setLastTransactionId('');
    phoneCountryRef.current = '';
  };

  return (
    <div className={`jgk-airtime ${embedded ? 'jgk-airtime--embedded' : ''}`}>
      <div className="jgk-airtime__header">
        <div className="jgk-airtime__title">Mobile Airtime</div>
        <div className="jgk-airtime__subtitle">
          Top up a phone in four quick steps.
        </div>
      </div>
      <div className="jgk-airtime__steps">
        {steps.map((item, index) => (
          <div
            key={item.key}
            className={`jgk-airtime__step ${
              index <= activeStep ? 'is-active' : ''
            }`}
          >
            <span className="jgk-airtime__step-index">{index + 1}</span>
            <span className="jgk-airtime__step-label">{item.label}</span>
          </div>
        ))}
      </div>

      {step === 0 && (
        <div className="jgk-airtime__card">
          <div className="jgk-airtime__card-title">Select carrier</div>
          <button type="button" className="jgk-airtime__option is-active">
            Auto-detect carrier
            <span className="jgk-airtime__option-sub">
              We'll detect after you enter a phone number.
            </span>
          </button>
          <div className="jgk-airtime__hint">
            {operatorData?.name
              ? `Last detected: ${operatorData.name}`
              : 'No carrier selected yet.'}
          </div>
          <div className="jgk-airtime__actions">
            <button
              type="button"
              className="jgk-airtime__button"
              onClick={() => {
                setStep(1);
                setError('');
              }}
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {step === 1 && (
        <form onSubmit={handleSubmit} className="jgk-airtime__card">
          <div className="jgk-airtime__card-title">Enter phone number</div>
          <div className="jgk-airtime__field">
            <label htmlFor="airtime-phone" className="jgk-airtime__label">
              Phone number
            </label>
            <PhoneInput
              country={'us'}
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              inputProps={{
                name: 'phone',
                required: true,
                id: 'airtime-phone',
              }}
              containerClass="jgk-airtime__phone"
              inputClass="jgk-airtime__phone-input"
              enableSearch
            />
          </div>
          {error && <div className="jgk-wallet__error">{error}</div>}
          <div className="jgk-airtime__actions">
            <button
              type="button"
              className="jgk-airtime__button--ghost"
              onClick={() => {
                setStep(0);
                setError('');
              }}
              disabled={loading}
            >
              Back
            </button>
            <button
              type="submit"
              className="jgk-airtime__button"
              disabled={loading || !phoneNumber}
            >
              {loading ? 'Checking...' : 'Continue'}
            </button>
          </div>
        </form>
      )}

      {step === 2 && (
        <div className="jgk-airtime__card">
          <div className="jgk-airtime__card-title">Select amount</div>
          <div className="jgk-airtime__summary">
            <div>
              <div className="jgk-airtime__summary-title">
                {operatorData?.name || 'Carrier'}
              </div>
              <div className="jgk-airtime__summary-sub">{phoneNumber}</div>
            </div>
            {operatorData?.logoUrls?.[1] ? (
              <img
                src={operatorData.logoUrls[1]}
                alt=""
                className="jgk-airtime__summary-logo"
                loading="lazy"
              />
            ) : null}
          </div>
          <div className="jgk-airtime__field">
            <label htmlFor="airtime-amount" className="jgk-airtime__label">
              Amount
            </label>
            <input
              type="number"
              id="airtime-amount"
              min={showMin}
              max={showMax}
              value={amount}
              onChange={handleChange}
              className="jgk-airtime__input"
              placeholder={`${showMin}`}
            />
            <div className="jgk-airtime__hint">
              {`Amount between $${showMin} and $${showMax}`}
            </div>
          </div>
          <div className="jgk-airtime__meta">
            {Number.isFinite(jgkAmount)
              ? `JGK spend: ${Math.round(jgkAmount)} JGK`
              : 'JGK spend: --'}
          </div>
          {error && <div className="jgk-wallet__error">{error}</div>}
          <div className="jgk-airtime__actions">
            <button
              type="button"
              className="jgk-airtime__button--ghost"
              onClick={() => {
                setStep(1);
                setError('');
              }}
            >
              Back
            </button>
            <button
              type="button"
              className="jgk-airtime__button"
              onClick={() => setStep(3)}
              disabled={!canContinueAmount || loading}
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="jgk-airtime__card">
          <div className="jgk-airtime__card-title">Confirm</div>
          <div className="jgk-airtime__confirm">
            <div className="jgk-airtime__confirm-row">
              <span>Carrier</span>
              <span>{operatorData?.name || 'Carrier'}</span>
            </div>
            <div className="jgk-airtime__confirm-row">
              <span>Phone</span>
              <span>{phoneNumber}</span>
            </div>
            <div className="jgk-airtime__confirm-row">
              <span>Amount</span>
              <span>{`$${amount}`}</span>
            </div>
            {deliveryAmount ? (
              <div className="jgk-airtime__confirm-row">
                <span>Delivery amount</span>
                <span>
                  {`${operatorData?.fx?.currencyCode || ''} ${deliveryAmount}`}
                </span>
              </div>
            ) : null}
            <div className="jgk-airtime__confirm-row">
              <span>JGK spend</span>
              <span>{`${Math.round(jgkAmount || 0)} JGK`}</span>
            </div>
          </div>
          {error && <div className="jgk-wallet__error">{error}</div>}
          <div className="jgk-airtime__actions">
            <button
              type="button"
              className="jgk-airtime__button--ghost"
              onClick={() => {
                setStep(2);
                setError('');
              }}
              disabled={loading}
            >
              Back
            </button>
            <button
              type="button"
              className="jgk-airtime__button"
              onClick={handleSend}
              disabled={!canContinueAmount || loading}
            >
              {loading ? (
                <ClipLoader size={18} color="#ffffff" loading={loading} />
              ) : (
                'Confirm'
              )}
            </button>
          </div>
        </div>
      )}

      {step === 4 && (
        <div className="jgk-airtime__card jgk-airtime__card--success">
          <div className="jgk-airtime__success-title">
            {success || 'Airtime added instantly.'}
          </div>
          <div className="jgk-airtime__success-sub">
            {`$${amount} sent to ${phoneNumber}`}
          </div>
          {lastTransactionId ? (
            <div className="jgk-airtime__success-meta">
              {`Transaction ID: ${lastTransactionId}`}
            </div>
          ) : null}
          <div className="jgk-airtime__actions">
            <button
              type="button"
              className="jgk-airtime__button"
              onClick={handleReset}
            >
              Top up another
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const Airtime = () => {
  const mobileView = useMobileView();

  return (
    <>
      {/* <Topbar /> */}
      {/* {mobileView && <TopbarNotification />} */}
      <div className="homeContainer">
        {!mobileView && <Sidebar />}
        <div className="feed">
          <div className="jgk-airtime-shell">
            <AirtimeTopUp />
          </div>
        </div>
        {!mobileView && <Rightbar />}
      </div>
    </>
  );
};

export default Airtime;
